export default {
  name: 'marking--orderOmsStatus',
};